import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { constants } from '../constants';
import React from 'react';
import AlertStateIcon from '../../public/AlertStateIcon.svg';
import authenticatedRoute from '@/views/AuthenticatedRoute';
function AccessUnavailable() {
    return (_jsx(Box, { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', children: _jsxs(Box, { textAlign: 'center', children: [_jsx("img", { src: AlertStateIcon, alt: '404', width: 120, height: 120, style: { marginBottom: 28 } }), _jsx(Typography, { variant: "h5", color: '#000000DE', mb: 1, fontWeight: 600, children: constants.title_Access_unavailable }), _jsx(Typography, { variant: "body2", color: '#333333', sx: { marginBottom: 3.75 }, children: constants.desc_Access_unavailable })] }) }));
}
export default authenticatedRoute(AccessUnavailable);
